import { FulfillmentName } from '@/types';
import { OrderAvailability } from '@domain/fulfillment-settings/blocs/order-availability';
import { useMemo } from 'react';
import { useNewOrderActionsContext } from '@/contexts/new-order-actions-context';
import { useNewOrderContext } from '@/contexts/new-order-context';
import { useUserContext } from '@/contexts/user-context';

export const useSupplierOrderAvailability = () => {
  const { supplierTimezone, availableOrderFulfillments } = useNewOrderContext();
  const { selectedRestaurantRelationship } = useUserContext();
  const { selectedFulfillment } = useNewOrderActionsContext();
  return useMemo(() => {
    return new OrderAvailability(
      availableOrderFulfillments,
      {
        restaurant: selectedRestaurantRelationship.timezone,
        supplier: supplierTimezone,
      },
      selectedFulfillment?.type || FulfillmentName.Delivery,
      true,
    );
  }, [
    availableOrderFulfillments,
    supplierTimezone,
    selectedFulfillment,
    selectedRestaurantRelationship.timezone,
  ]);
};
